import React, { useCallback } from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { useNavigate } from '@tanstack/react-router';



const ClientPatientTableRow = (props) => {
	const id = props.row.patient_id,
		  navigate = useNavigate();

	const handleNavigate = useCallback(() => {
		navigate({ to: `/patients/view/${id}` });
	}, [ navigate, id ]);


	return (
		<Table.Row
			{...props}
			style={{
				cursor: 'pointer',
			}}
			onClick={handleNavigate}
		/>
	);
};


export default ClientPatientTableRow;